import axiosInstance from "./axios";

export interface RoomFilters {
  genre_ids?: number[];
  min_rating?: number;
  year_from?: number;
  year_to?: number;
}

export interface RoomParticipant {
  user_id: number;
  username: string;
  joined_at: string;
  is_active: boolean;
  last_activity_at: string;
}

export interface RoomMatch {
  id: number;
  movie_id: number;
  movie_title: string;
  movie_poster_path: string;
  matched_at: string;
  is_selected: boolean;
}

export interface RoomDetail {
  id: number;
  code: string;
  status: "waiting" | "active" | "completed" | "expired" | "cancelled";
  filters: RoomFilters;
  creator_id: number;
  creator_username: string;
  participants: RoomParticipant[];
  matches: RoomMatch[];
  created_at: string;
  expires_at: string;
  started_at: string | null;
}

export interface RoomMovie {
  id: number;
  title: string;
  poster_path: string;
  backdrop_path: string;
  release_date: string;
  vote_average: number;
  imdb_rating: number | null;
  overview: string;
  genres: string;
  popularity: number;
}

export interface RoomMoviesResponse {
  results: RoomMovie[];
  has_more: boolean;
  offset: number;
}

export interface SwipeResult {
  match: boolean;
  match_id?: number;
  movie_id?: number;
  movie_title?: string;
}

export interface RoomStatus {
  status: string;
  participants: RoomParticipant[];
  matches: RoomMatch[];
  updated_at: string;
}

const roomApi = {
  create: (filters: RoomFilters = {}) =>
    axiosInstance.post<RoomDetail>("/rooms/", filters),

  getDetail: (code: string) =>
    axiosInstance.get<RoomDetail>(`/rooms/${code}/`),

  join: (code: string) =>
    axiosInstance.post<RoomDetail>(`/rooms/${code}/join/`),

  start: (code: string) =>
    axiosInstance.post<RoomDetail>(`/rooms/${code}/start/`),

  getMovies: (code: string, batchSize = 10) =>
    axiosInstance.get<RoomMoviesResponse>(
      `/rooms/${code}/movies/?batch_size=${batchSize}`
    ),

  swipe: (code: string, movieId: number, action: "like" | "dislike") =>
    axiosInstance.post<SwipeResult>(`/rooms/${code}/swipe/`, {
      movie_id: movieId,
      action,
    }),

  getMatches: (code: string) =>
    axiosInstance.get<RoomMatch[]>(`/rooms/${code}/matches/`),

  selectMatch: (code: string, matchId: number) =>
    axiosInstance.post<RoomMatch>(`/rooms/${code}/select/${matchId}/`),

  close: (code: string) =>
    axiosInstance.post(`/rooms/${code}/close/`),

  getStatus: (code: string) =>
    axiosInstance.get<RoomStatus>(`/rooms/${code}/status/`),
};

export default roomApi;
